import angular from 'angular';
import toolbarService from "../../../../Toolbar/ToolbarService";
import sectionsLibraryService from "../../../SectionsLibraryService";
import workspaceElement from "../../../../Workspace/WorkspaceElement/WorkspaceElement";
import Paddings from "../../../../ConfigParameters/ConfigCollections/Paddings";
import PaddingsItems from "../../../../ConfigParameters/ConfigCollections/PaddingsItems";
import ItemSpacing from "../../../../ConfigParameters/ConfigParameters/ItemSpacing";
import ItemBorderRadius from "../../../../ConfigParameters/ConfigParameters/ItemBorderRadius";
import Backgrounds from "../../../../ConfigParameters/ConfigCollections/Backgrounds";
import Align from "../../../../ConfigParameters/ConfigParameters/Align";
import TextColor from "../../../../ConfigParameters/ConfigParameters/TextColor";
import BackgroundItemColor from "../../../../ConfigParameters/ConfigParameters/BackgroundItemColor";
import ConfigParameter, {gettext} from "../../../../ConfigParameters/ConfigParameter";
import MenuItemSelect from "../../../../ConfigParameters/ConfigParameters/MenuItemSelect";

import './Menu.scss';
import CustomClassName from "../../../../ConfigParameters/ConfigParameters/CustomClassName";

const MODULE_NAME = 'pageMenu';

const creatorPageMenu = {
    bindings: {
        elementModel: '=',
        context: '<',
        content: '=',
        uid: '<'
    },
    template: require('./menu.html'),
    controller: function (ToolbarService) {
        /** @ngInject */

        let defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        this.$onInit = () => {
            this.elementModel = angular.copy(angular.extend(defaultConfig, this.elementModel));
        };

    }
};

export default angular.module(
    'cms.creator.page.menu',
    [sectionsLibraryService, toolbarService, workspaceElement]
).run(function (SectionsLibraryService, ToolbarService, UniqueIdGenerator, gettext) {

    SectionsLibraryService.registerSection({
        icon: 'menu',
        type: MODULE_NAME,
        label: gettext('Menu'),
        group: 'page',
        groups: {
            mainConfig: {
                label: gettext('Main config'),
                isOpen: true,
                type: 'mainConfig'
            },
            position: {
                label: gettext('Position'),
                isOpen: false,
                type: 'position'
            },
            itemPosition: {
                label: gettext('Item position'),
                isOpen: false,
                type: 'itemPosition'
            },
            advanced: {
                label: gettext('Advanced'),
                isOpen: false,
                type: 'advanced'
            }
        }
    });

    let align = new Align();
    align.setDefaultValue('right');

    let textColor = new TextColor();
    textColor.setDefaultValue('#192a3a');

    ToolbarService.registerSectionSchema(MODULE_NAME, {
        ...(new ConfigParameter('sectionId', 'hidden', gettext('Section Id'), null, (type) => UniqueIdGenerator.generate(type))),
        ...(new ConfigParameter('uid', 'hidden', '', null, () => UniqueIdGenerator.generate('element-uid'))),
        ...(new MenuItemSelect()),
        ...(textColor),
        ...(new BackgroundItemColor()),
        ...(new ItemBorderRadius()),
        ...(new Backgrounds()),
        ...(align),
        ...(new Paddings()),
        ...(new ItemSpacing()),
        ...(new PaddingsItems()),
        ...(new CustomClassName())
    });

})
    .component('cmsCreatorPageMenu', creatorPageMenu).name;




// WEBPACK FOOTER //
// ./src/cmsCore/Creator/SectionsLibrary/Sections/Page/Menu/Menu.js